module.exports = __webpack_public_path__ + "img/horizontal_7_3_3009.454e9c97.png";